<template>
  <Input
    :placeholder="$t('Stand text placeholder', { limit })"
    id="standText"
    classes="col-12 stand-text"
    name="standText"
    rules="required"
    :value="product.attributes.standText"
    @updated-value="updatedInputField"
    :label="label"
    :maxlength="limit"
  />
</template>
<script>
import { mapGetters } from "vuex";
import Input from "../../../partials/input/Input";
import useProduct from "../../useProduct";

export default {
  components: {
    Input,
  },
  props: {
    type: {
      type: String,
    },
    label: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      product: "product/getProduct",
    }),
  },
  setup() {
    const limit = 30;
    const { updatedInputField } = useProduct();

    return {
      limit,
      updatedInputField,
    };
  },
};
</script>
